import React from "react";
import Banner from "./elements/banner"
import ChatWidget from "./elements/chatWidget";
import Header from "./header";
import Footer from "./footer";
import { Helmet } from "react-helmet";
import {graphql, useStaticQuery} from "gatsby";

export default function Layout({ children, className, isDifferentLogo = false }) {
	const labelsQuery = useStaticQuery(graphql`
		query {
			allContentfulLabel {
				nodes {
					key
					value {
						raw
					}
					isEnabled
				}
			}
		}
	`);

	const labels = labelsQuery.allContentfulLabel.nodes;

	return (
		<>
			<Helmet>
				<script src='https://use.fontawesome.com/d8fa70d15d.js' />
				<script type="text/javascript" charset="utf-8"
						src="//sleeknotecustomerscripts.sleeknote.com/136625.js"
				></script>
			</Helmet>
			<Banner/>
			<Header isDifferentLogo={isDifferentLogo}/>
			{children}
			<Footer />
			<ChatWidget /> 
		</>
	);
}
